import { ModalService } from '@agentifai/core-ui/modal';
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, Subject } from 'rxjs';
import { ConfirmationWindowComponent } from '../../shared/components/confirmation-window/confirmation-window.component';
import { CanDeactivateComponent, ConfirmationWindowConfig } from '../models';

/**
 *  Guard to prevent navigation to routes that require not to be authenticated.
 *
 * @export
 */
@Injectable({ providedIn: 'root' })
export class UnsavedChangesCanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {
    constructor(private modalService: ModalService, private translate: TranslateService) {}

    canDeactivate(component: CanDeactivateComponent): Observable<boolean> {
        if (!component.canDeactivate()) {
            const confirmationSubject = new Subject<boolean>();
            const windowConfig = { ...this.defaultConfig(), ...component.confirmationWindowConfig };
            const ref = this.modalService.show(ConfirmationWindowComponent, {
                closeButton: false,
                data: {
                    text: windowConfig.question,
                    confirmLabel: windowConfig.confirmLabel,
                    rejectLabel: windowConfig.rejectLabel,
                    title: windowConfig.title,
                    responseSubject: confirmationSubject,
                },
            });

            const confirmationSubjectObs = confirmationSubject.asObservable();
            confirmationSubjectObs.subscribe(() => {
                ref.close();
            });

            return confirmationSubjectObs;
        }
        return of(true);
    }

    private defaultConfig(): ConfirmationWindowConfig {
        return {
            title: this.translate.instant('SHARED.CONFIRMATION_WINDOW.TITLE'),
            question: this.translate.instant('SHARED.CONFIRMATION_WINDOW.QUESTION'),
            confirmLabel: this.translate.instant('COMMON.YES'),
            rejectLabel: this.translate.instant('COMMON.NO'),
        };
    }
}
